/**
 * Updates the shipping rate text when a new variant is selected.
 */
function initVariantShippingUpdater() {
  document.addEventListener('change', function(event) {
    // Look for variant change inputs (standard in Dawn and most themes)
    if (event.target.name === 'id' || event.target.closest('.variant-input')) {
      
      const variantId = event.target.value;
      const ratesContainer = document.getElementById('variant-shipping-rates');
      const displayContainer = document.getElementById('variant-shipping-info');
      
      if (!ratesContainer || !displayContainer) return;

      const rates = JSON.parse(ratesContainer.innerHTML);
      const valueSpan = displayContainer.querySelector('.shipping-value');
      const newRate = rates[variantId];

      if (newRate && newRate.trim() !== "") {
        displayContainer.style.display = 'block';
        if (valueSpan) valueSpan.textContent = newRate;
      } else {
        // Hide the box if the new variant has no shipping rate defined
        displayContainer.style.display = 'none';
      }
    }
  });
}

// Initialize when the DOM is ready
document.addEventListener('DOMContentLoaded', initVariantShippingUpdater);